import React from 'react'

/**
 * Helpers and types
 */
import {pure} from '@react/store'
import {http} from '@helpers/common'

/**
 * Components
 */
import Button from '@components/button'
import {DefaultComponentProps} from '@interface/common'

/**
 * Template Settings Screen
 */
export default pure(({store}:DefaultComponentProps) => {
  const state = store.useLocalState({
    saving: false,
    safetyPrompt: {
      content: '',
    },
  })

  React.useEffect(() => {
    http.get('/settings', {
      query: {
        fields: [
          'safetyPrompt',
        ]
      }
    })
    .then(({status, result}:any) => {
      if(status === 200 && result) {
        state.set(result)
      }
    })
    .catch(console.log)
  }, [])

  
  /**
   * Save settings
   */
  function save() {
    state.set({
      saving: true
    })

    http.put('/settings', {
      data: {
        safetyPrompt: state.safetyPrompt
      }
    })
    .then(({status, result}:any) => {
      if(status === 200) {
        if(result) {
          setTimeout(() => {
            state.set({saving: false, ...result})
          }, 1000)
        }
      }
    })
    .catch(console.log)
  }


  /**
   * Handle change
   */
  function change(name: string, data: object) {
    state.set((state: any) => {
      return {
        [name]: {...state[name], ...data}
      }
    })
  }

  return (
    <div className="box">
      <header className="line">
        <h3>Content</h3>
      </header>

      <div
        style={{
          width: '50%'
        }}>
        <fieldset className="fields">
          <h4>Safety Prompt</h4>
          <p>List of harm types that can be used as a safety filter and for content moderation.</p>
          
          <div className="field">
            <textarea
              value={state.safetyPrompt.content}
              onChange={(e) => {
                change('safetyPrompt', {content: e.target.value})
              }}
            />
          </div>
        </fieldset>
      </div>
      <Button
        label={'Save'}
        style={{
          marginTop: 30
        }}
        preload={state.saving}
        onClick={save}
        className={'button-2'}
      />
    </div>
  )
})